module.exports = __webpack_public_path__ + "img/facings-techniques.70ee9cee.jpg";